"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tronTokens = void 0;
exports.tronTokens = {
    otherTokens: [{ name: 'WTRX', symbol: 'WTRX', decimals: 6, address: 'TNUC9Qb1rRpS5CbWLmNMxXBjyFoydXjWFR' }]
};
